module.exports = __webpack_public_path__ + "static/media/close.4ceeeab0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.svg
// module id = 845
// module chunks = 7